var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input-autocomplete", {
    attrs: {
      value: _vm.value,
      items: _vm.filteredOptions,
      label: _vm.label,
      fancy: _vm.fancy,
    },
    on: {
      input: function ($event) {
        return _vm.setValue($event)
      },
      "item-click": function ($event) {
        return _vm.optionClicked($event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (p) {
          return [
            _c("div", { staticClass: "text" }, [_vm._v(_vm._s(p.item.text))]),
            _c("div", { staticClass: "value" }, [_vm._v(_vm._s(p.item.value))]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }